import script from "./ContentReactions.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentReactions.vue?vue&type=script&setup=true&lang=js"

import "./ContentReactions.vue?vue&type=style&index=0&id=43b52312&lang=scss"

const __exports__ = script;

export default __exports__